import React, {Component} from 'react';
import { connect } from 'react-redux';
import {Container} from 'react-bootstrap';
import ThreeColumnGrid from '../components/three-columns-grid';
import SectionHeading from '../components/section-heading';
import QuoteBlock from '../components/quote-block';
import CategoryFilter from '../components/services-category-filter';
import ToggledDiv from '../components/toggled-divs';
import HomeHeader from '../components/home/home-header';
import ContactBlock from '../components/contact-block';
import RelatedBlogs from '../components/related-blogs';

import { fetchLatestArticles, fetchLatestCaseStudies } from '../redux/actions/actions';

class Home extends Component {
  componentDidMount() {
    let { loadLatestArticles, loadLatestCaseStudies } = this.props;
    loadLatestCaseStudies();
    loadLatestArticles();
  }
  render() {
    let { latestArticles, latestCaseStudies } = this.props;
    return (
      <>
      <HomeHeader/>
      <Container>
        <SectionHeading subText="How can we help" heading="Creative Services" align="heading-center"/>
        <ThreeColumnGrid/>
        <QuoteBlock/>
        <CategoryFilter loadMore={true} articleList={latestCaseStudies}/>
        <ToggledDiv/>
      </Container>
      <section className="le-testimonials">

      </section>
      <Container>
        <ContactBlock/>
        <SectionHeading subText="FROM OUR BLOG" heading="Recent news/ Updates" align="heading-center"/>
        <RelatedBlogs loadMore={true} articleList={latestArticles}/>
      </Container>
      </>
    );
  }
}

const maptStateToProps = ({linenedges}) => ({
  latestArticles: linenedges.latestArticles,
  latestCaseStudies: linenedges.latestCaseStudies
});

const mapDispatchToProps = dispatch => ({
  loadLatestArticles: async () => await dispatch(fetchLatestArticles()),
  loadLatestCaseStudies: async () => await dispatch(fetchLatestCaseStudies())
});

export default connect(maptStateToProps, mapDispatchToProps)(Home);